import defaultDataBB, {
  AppBBWaardecheckDefaultData,
} from '~/components/page/Apps/BBWaardecheck/defaultData';
import defaultDataVBO, {
  AppVBOWaardecheckDefaultData,
} from '~/components/page/Apps/VBOWaardecheck/defaultData';
import { WaardecheckApp } from '../..';

export type WaardecheckDefaultData =
  | AppVBOWaardecheckDefaultData
  | AppBBWaardecheckDefaultData;

export type DefaultDataProps = {
  accountName: string;
  appType: WaardecheckApp;
};

const getDefaultData = ({
  appType,
  accountName,
}: DefaultDataProps): WaardecheckDefaultData => {
  switch (appType) {
    case WaardecheckApp.VBO:
      return defaultDataVBO({ accountName });
    case WaardecheckApp.BB:
    default:
      return defaultDataBB({ accountName });
  }
};

export default getDefaultData;
